<template>
  <div class="content-area shuttle-plan-list">
    <hero-bar>
      {{ $t('shuttlePlans') }}

      <b-tooltip slot="right" :label="$t('refresh')" type="is-dark" position="is-bottom">
        <b-button
          id="refresh-button"
          class="mr-10"
          size="is-circle"
          type="is-link"
          outlined
          :class="{ 'is-loading': refreshLoading }"
          icon-left="refresh"
          @click="refresh"
        />
      </b-tooltip>

      <b-button
        v-if="checkPermission('shuttle_create')"
        id="new-plan"
        slot="right"
        tag="router-link"
        :to="{ name: 'shuttle_create'}"
        icon-left="comment-plus"
        type="is-link"
      >
        Yeni Servis Planı
      </b-button>
    </hero-bar>

    <section class="section is-main-section">
      <card-component class="has-table has-mobile-sort-spaced bg-none">
        <smart-table
          ref="table"
          data-url="shuttle-list"
          default-sort="id"
          :loading.sync="refreshLoading"
        >
          <template slot="action-column" slot-scope="{ row }">
            <b-table-column custom-key="actions" width="110">
              <b-tooltip :label="$t('delete')" type="is-dark" position="is-bottom">
                <b-button outlined size="is-small" class="button-green is-danger mr-5 only-icon" icon-left="close-circle"
                          :class="{ 'is-loading': hasLoading(row.id) }"
                          @click="deletePlan(row.id)"
                />
              </b-tooltip>
              <b-button
                outlined
                size="is-small"
                class="button-purble btn-details"
                tag="router-link"
                :to="{ name: 'shuttle_detail', params: { id: row.id }}"
                icon-left="arrow-right-bold"
              >
                {{ $t('edit') }}
              </b-button>
            </b-table-column>
          </template>
        </smart-table>
      </card-component>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ShuttleList',
  title: ({ $i18n }) => $i18n.t('titles.shuttlePlanList'),
  components: {
    HeroBar: () => import('@/components/HeroBar'),
    CardComponent: () => import('@/components/CardComponent'),
    SmartTable: () => import('@/components/SmartTable'),
  },
  data () {
    return {
      refreshLoading: false,
      deleteLoading: null,
    }
  },
  computed: {
    //
  },
  methods: {
    refresh () {
      this.$refs.table.loadData()
    },
    hasLoading (id) {
      return this.deleteLoading == id
    },
    async deletePlan (id) {
      this.deleteLoading = id
      let shuttleRegisterCount;

      try {
        const shuttleRegisterRequest = await this.$http.get(`shuttle-count/${id}`);
        shuttleRegisterCount = shuttleRegisterRequest.data.register_count;
      } catch {
        shuttleRegisterCount = 0
      }

      const ekAlert = shuttleRegisterCount > 0 ? `Bu güzergaha ait ${shuttleRegisterCount} başvuru var, silerseniz o basvurular da silinecektir <br>` : null;

      this.$buefy.dialog.confirm({
          title: 'Servis Planı Sil',
          message: `${ekAlert}Servis Planını <b>silmek</b> istediğinizden emin misiniz?`,
          cancelText: 'İptal',
          confirmText: 'Planı Sil',
          type: 'is-danger',
          hasIcon: true,
          onConfirm: () => {
            this.$http
              .delete(`shuttle-remove/${id}`)
              .then(() => {
                this.$buefy.toast.open({ message: 'Servis Planı Silindi.', type: 'is-success' })
                this.refresh();
                this.deleteLoading = null
              })
          },
          onCancel: () => {
            this.deleteLoading = null
          }
      })
    }
  }
}
</script>
